<!-- Structure from git/truth-first-look/src/pages/Dashboard.tsx -->
<div class="min-h-screen bg-background ts-preview-lovable pb-[4.5rem] md:pb-0">
  <div class="max-w-[1280px] mx-auto flex">
    <aside
      class="sticky top-0 h-screen w-[68px] xl:w-[260px] flex-shrink-0 border-r border-border hidden md:block">
      <app-lovable-left-sidebar-nav></app-lovable-left-sidebar-nav>
    </aside>

    <main class="flex-1 min-w-0 max-w-[600px] border-r border-border">
      <app-lovable-main-feed
        [posts]="samplePosts"
        [(activeTab)]="feedTab">
      </app-lovable-main-feed>
    </main>

    <aside
      class="sticky top-0 h-screen w-[350px] flex-shrink-0 overflow-y-auto hidden lg:block px-4">
      <app-lovable-right-rail></app-lovable-right-rail>
    </aside>
  </div>

  <app-lovable-mobile-bottom-nav></app-lovable-mobile-bottom-nav>
</div>
